export default __webpack_public_path__ + "static/media/down-arr.4e3208b9.svg";